// ----------------------------------------------------------------------
// V2 Modern Lists Styling

import { alpha } from '@mui/material/styles';

export default function Lists(theme) {
  const primaryMain = '#7635dc';

  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: alpha(primaryMain, 0.06)
          },
          '&.Mui-selected': {
            backgroundColor: alpha(primaryMain, 0.1),
            '&:hover': {
              backgroundColor: alpha(primaryMain, 0.15)
            }
          }
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: 'inherit',
          minWidth: 'auto',
          marginRight: theme.spacing(2)
        }
      }
    },
    MuiListItemAvatar: {
      styleOverrides: {
        root: {
          minWidth: 'auto',
          marginRight: theme.spacing(2)
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          marginTop: 0,
          marginBottom: 0
        },
        multiline: {
          marginTop: 0,
          marginBottom: 0
        }
      }
    }
  };
}
